import React from 'react';
import ReactDom from 'react-dom';
import {render, createStore, connect} from '../src/frame/index';

import Home from './Home';
import Model from './model';

createStore([Model]);

ReactDom.render(<Home />, document.getElementById('app'));